export default __webpack_public_path__ + "static/media/tag-blue.a566850a.svg";